import React, { Component } from "react";
import Typical from "react-typical";
import Switch from "react-switch";
import Navigation from "./Navigation"

class Header extends Component {
  titles = [];
  hero = "";

  constructor() {
    super();
    this.state = { checked: false };
    this.onThemeSwitchChange = this.onThemeSwitchChange.bind(this);
  }

  onThemeSwitchChange(checked) {
    this.setState({ checked });
    this.setTheme();
    this.forceUpdate();
  }

  setTheme() {
    var dataThemeAttribute = "data-theme";
    var body = document.body;
    var newTheme =
      body.getAttribute(dataThemeAttribute) === "dark" ? "light" : "dark";
    body.setAttribute(dataThemeAttribute, newTheme);
  }

    getCurrentHeroBackground() {
        const theme = document.body.getAttribute("data-theme");
        return theme === "dark"
            ? process.env.PUBLIC_URL + "/images/hero_bg_dark.png"
            : process.env.PUBLIC_URL + "/images/hero_bg.png";
    }


    render() {
    if (this.props.sharedData) {
      // var name = this.props.sharedData.name;
      this.titles = this.props.sharedData.titles.map(x => [ x.toUpperCase(), 1500 ] ).flat();
      this.hero = this.props.sharedData.hero;
    }

      const HeaderTitleTypeAnimation = React.memo(() => {
          const steps = this.hero
              .split(/<br\s*\/?>/i)
              .map(s => [s.trim(), 1500])
              .flat()
              .filter(Boolean);
          return <Typical className="title-styles" steps={steps} loop={10} />;
      }, (props, prevProp) => true);
    return (
        <header
            id="home"
            style={{
                alignItems: "center",
                display: 'block',
                backgroundImage: `url(${this.getCurrentHeroBackground()})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                transition: "background-image 0.5s ease-in-out",
            }}
        >
        <div className="navigation">
          <Navigation/>
        <div className="switch">
        <Switch
          checked={this.state.checked}
          onChange={this.onThemeSwitchChange}
          offColor="#ddb9b1"
          onColor="#353535"
          className="react-switch mx-auto"
          width={90}
          height={40}
          uncheckedIcon={
            <span
              className="iconify"
              data-icon="twemoji:owl"
              data-inline="false"
              style={{
                display: "block",
                height: "100%",
                fontSize: 25,
                textAlign: "end",
                marginLeft: "20px",
                color: "#353239",
              }}
            ></span>
          }
          checkedIcon={
            <span
              className="iconify"
              data-icon="noto-v1:sun-with-face"
              data-inline="false"
              style={{
                display: "block",
                height: "100%",
                fontSize: 25,
                textAlign: "end",
                marginLeft: "10px",
                color: "#353239",
              }}
            ></span>
          }
          id="icon-switch"
        />
        </div>
        </div>
              <br />
            <div className="title-container">
    <HeaderTitleTypeAnimation />
</div>
      </header>
    );
  }
}

export default Header;
